import React, { FC } from 'react';
import { ReactComponent as PlusLightIcon } from '../../../../assets/images/multiAccount/plusIconLight.svg';
import { ReactComponent as PlusDarkIcon } from '../../../../assets/images/multiAccount/plusIconDark.svg';
import { useAppSelector } from '../../../../hooks/redux';

interface PlusIconProps {
  className?: string;
}

const defaultProps = {
  className: '',
};

export const PlusIcon: FC<PlusIconProps> = ({ className }) => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (true) {
      case colorTheme === 'light': {
        return <PlusLightIcon className={className} />;
      }
      case colorTheme === 'dark': {
        return <PlusDarkIcon className={className} />;
      }
      default: {
        return <PlusLightIcon className={className} />;
      }
    }
  };

  return getIcon(theme);
};

PlusIcon.defaultProps = defaultProps;
